import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spin, Checkbox } from 'antd';
import Panel from '@/components/Panel';
import { createPortal } from 'react-dom';
import { getPanelMaxWidth, getPanelWidth } from '@/services/helper/panelSizeHelper';
import { chooseExcelTable, choosePDFTable, updateTemplateChoosePanel } from '../store/SignOffTemplate/action';
import { deleteVerification } from '../store/project/action';
import { SIGN_OFF_TEMPLATE } from '../../../constants/treeConstants';
import EditableTable from '../../../components/EditableTable';
import { EXCEL, PDF } from '../../../constants/fileType';
import ElementListener from '@/services/helper/elementListener';
import './index.css';

class TemplateChoosePanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "0",
      sheetNumbers: [],
      error: null,
      headerHeight: 100
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    this.tableListener && this.tableListener.disconnect();
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 2400),
    })
  }

  componentDidUpdate(prevProps) {
    const { tables = [] } = this.props;
    if (tables.length !== prevProps.tables.length) {
      this.initValue()
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.tableResize()
    this.initValue()
  }

  tableResize = () => {
    this.tableRoot = document.getElementById('cascade-template-choose-panel');
    this.tableListener = new ElementListener({ targetNode: this.tableRoot, attributesHandle: this.attributesHandle });
    this.tableListener.observe();
    this.attributesHandle();
  }

  attributesHandle = () => {
    if (!this.tableRoot) return;
    const header = this.tableRoot.querySelector('.ant-table-header');
    if (!header) return;
    const headerHeight = header.offsetHeight;
    if (headerHeight === this.state.headerHeight) return;
    this.setState({
      headerHeight
    });
  };

  initValue = () => {
    const { tables = [] } = this.props
    const value = tables.length ? tables[0].sheetNum : 0
    this.setState({
      value: String(value)
    })
  }

  closeModal = () => {
    const { verificationId, templateType } = this.props
    if (templateType === PDF) {
      this.props.deleteVerification(SIGN_OFF_TEMPLATE, verificationId);
    }
    this.props.updateTemplateChoosePanel({}, true)
  }

  changeTab = (key) => {
    this.setState({
      value: key
    })
  }

  chooseTable = () => {
    const { value, sheetNumbers } = this.state;
    const { templateType } = this.props
    if (templateType === EXCEL) {
      if (sheetNumbers.length > 0) {
        this.props.chooseExcelTable(sheetNumbers)
        this.setState({
          error: null
        })
      } else {
        this.setState({
          error: 'Please select at least one sheet.'
        })
      }
    } else {
      this.props.choosePDFTable(value)
    }
  }

  footerRender = () => {
    const { tables } = this.props;
    return <Button onClick={this.chooseTable} type="primary" disabled={tables && tables.length ? false : true}>Choose</Button>
  }

  changeSheetNums = (key, e) => {
    e && e.stopPropagation();
    const { sheetNumbers, error } = this.state;
    const newSheetNums = e.target.checked ? [...sheetNumbers, key] : sheetNumbers.filter(k => k !== key);
    if (newSheetNums.length > 0 && error) {
      this.setState({
        error: null
      })
    }
    this.setState({ sheetNumbers: newSheetNums });
  };

  isAllSelected = () => {
    const { sheetNumbers } = this.state;
    const { tables = [] } = this.props;
    return tables.length && sheetNumbers.length === tables.length;
  };

  isIndeterminate = () => {
    const { sheetNumbers } = this.state;
    const { tables = [] } = this.props;
    return sheetNumbers.length > 0 && sheetNumbers.length < tables.length;
  }

  changeSelectAll = (e) => {
    const checked = e.target.checked;
    const { tables = [] } = this.props;
    if (checked) {
      this.setState({ sheetNumbers: tables.map(item => String(item.sheetNum)) });
    } else {
      this.setState({ sheetNumbers: [] });
    }
  }

  tableRender = () => {
    const { value, sheetNumbers } = this.state;
    const { tables = [], templateType } = this.props;
    if (!tables.length) {
      return null
    }
    const active = tables.find(t => String(t.sheetNum) === value)
    return (
      <div className="cascade-template-choose-tabs-content">
        <div className="cascade-template-choose-tabs-content-left">
          {templateType === EXCEL && (
            <div className="cascade-template-choose-tabs-header">
              <Checkbox
                checked={this.isAllSelected()}
                indeterminate={this.isIndeterminate()}
                onChange={this.changeSelectAll}
              >
                Template Sheets
              </Checkbox>
            </div>
          )}
          <div className="cascade-template-choose-tabs-list">
            {tables.map(item => {
              const activeTab = String(item.sheetNum) === value
              return <div
                key={item.sheetNum}
                className={`cascade-template-choose-tab-item ${activeTab ? 'active' : ''}`}
                onClick={() => this.changeTab(String(item.sheetNum))}
              >
                {templateType === EXCEL && (
                  <Checkbox
                    checked={sheetNumbers.includes(String(item.sheetNum))}
                    onChange={(e) => this.changeSheetNums(String(item.sheetNum), e)}
                    onClick={(e) => e.stopPropagation()}
                  />
                )}
                <span className="cascade-template-choose-tab-title" title={item.sheetName}>{item.sheetName}</span>
              </div>
            })}
          </div>
          <div className="cascade-template-choose-tabs-footer">
            <Button type="primary" onClick={this.chooseTable}>Choose</Button>
          </div>
        </div>
        <div className="cascade-template-choose-tabs-content-right">
          {active ? this.tableContent(active.data, active.columns) : null}
        </div>
      </div>
    )
  }

  tableContent = (data, columns) => {
    if (!data || !data.length) {
      return;
    }
    const { headerHeight } = this.state
    const getFlexColumns = (columns) => {
      return columns.map(item => ({
        title: item.title,
        dataIndex: item.dataIndex,
        style: { flex: 1 },
        render: (text) => <span>{typeof text === 'object' ? JSON.stringify(text) : text}</span>,
        children: item.children ? getFlexColumns(item.children) : undefined,
      }));
    };
    const _columns = getFlexColumns(columns);
    return <EditableTable
      id={'template-table-root'}
      rowKey="rowIndex"
      columns={_columns}
      size="small"
      dataSource={data}
      className="cascade-template-pdf-choose-table"
      scroll={{ y: 890 - headerHeight }}
    />
  }

  render() {
    const { maxWidth, error } = this.state;
    const { loading = false, loadingTip, failed, error: msgError } = this.props;
    const setting = { defaultWidth: 2400 }
    const content = (
      <Panel
        className='cascade-top-template-option-panel'
        title={<div className='cascade-top-template-option-panel-name'>Choose Table</div>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, setting)}
        position="panel-left-280"
        draggable
        minWidth={200}
        minHeight={400}
        maxHeight={1200}
        id={'cascade-template-choose-panel'}
      >
        <Spin spinning={loading} tip={loadingTip}>
          <div className="cascade-template-pdf-choose-content">
            {
              failed ? <span className='cascade-template-choose-table-error-msg'>Error: {msgError}</span> : this.tableRender()
            }
            {error && <span className='cascade-template-choose-table-error-msg'>Error: {error}</span>}
          </div>
        </Spin>
      </Panel>
    )
    return createPortal(content, this.dialogRoot)
  }
}

const mapState = (state) => {
  const { CascadeReducer: {
    SignOffTemplate: { templateChoosePanel: { loading, loadingTip, tables = [], failed, verificationInfo = {}, error, templateType } },
  } } = state;
  const { res = {} } = verificationInfo;
  const { verificationId } = res;
  return {
    loading,
    loadingTip,
    tables,
    failed,
    verificationId,
    error,
    templateType
  };
}

const mapDispatch = (dispatch) => ({
  choosePDFTable(value) {
    dispatch(choosePDFTable(value))
  },
  chooseExcelTable(sheetNumbers) {
    dispatch(chooseExcelTable(sheetNumbers))
  },
  deleteVerification(dataType, id) {
    dispatch(deleteVerification(dataType, id))
  },
  updateTemplateChoosePanel(info, replace) {
    dispatch(updateTemplateChoosePanel(info, replace))
  }
})

export default connect(mapState, mapDispatch)(TemplateChoosePanel);